import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RefreshConnexionComponent } from './refresh-connexion.component';

@NgModule({
  declarations: [RefreshConnexionComponent],
  imports: [CommonModule, MatButtonModule],
  exports: [RefreshConnexionComponent, CommonModule]
})
export class RefreshConnexionModule {}
